import { render, staticRenderFns } from "./help-bug.vue?vue&type=template&id=28924f45&scoped=true"
import script from "./help-bug.vue?vue&type=script&lang=js"
export * from "./help-bug.vue?vue&type=script&lang=js"
import style0 from "./help-bug.vue?vue&type=style&index=0&id=28924f45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28924f45",
  null
  
)

export default component.exports